import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { apiStatuses } from '../actions/Actions';
import {
  IAddress,
  IProductInfo,
  IReferer,
  ISessionInfo,
  IState,
  IUserInfo,
} from '../CustomTypes';
import { trackPulseEngagementEvent } from '../PulseUtils';
import {
  getRedirectUrlInLocalStorage,
  shouldSkipSelectPayment,
} from '../fastflowUtils';
import { Button, classNames, Margin, Width } from '@snoam/pinata';
import ReactHtmlParser from 'react-html-parser';
import { transformHtmlFactory } from '../page-components/HtmlParser';

export interface IProps
  extends RouteComponentProps<Record<string, never>, Record<string, never>> {
  fetchUserInfo: IUserInfo;
  productInfo: IProductInfo;
  address: IAddress;
  sessionInfo: ISessionInfo;
  referer: IReferer;
  userInfo: IUserInfo;
}

export interface IYesPleaseState {
  showLoyaltyError: boolean;
}

const styleClass = {
  orderButton: classNames(Width.W_FULL, Margin.MY_4),
};

export class YesPlease extends React.Component<IProps, IYesPleaseState> {
  constructor(props: IProps) {
    super(props);
    this.nextStep = this.nextStep.bind(this);
    this.state = { showLoyaltyError: false };
  }

  public render() {
    const btnText = ReactHtmlParser(
      this.props.productInfo.orderButtonText || 'Bestill',
      {
        transform: transformHtmlFactory({}, true),
      },
    );

    return (
      <div>
        <Button
          className={styleClass.orderButton}
          onClick={this.nextStep}
          data-testing={'proceed-with-order-btn'}
          text={btnText}
        />
      </div>
    );
  }

  private nextStep() {
    const { productInfo, fetchUserInfo, userInfo } = this.props;
    if (productInfo.loyaltyPartner && !userInfo.valid) {
      return;
    }

    const redirectParams = getRedirectUrlInLocalStorage();
    trackPulseEngagementEvent({}, 'Buy button clicked');

    if (
      ![productInfo, fetchUserInfo]
        .map((s) => s.apiStatus)
        .find((s) => s !== apiStatuses.SUCCESS)
    ) {
      if (!productInfo.pureDigital) {
        if (this.props.address.zipCode && this.props.address.city) {
          this.props.history.push(
            `/products/${this.props.productInfo.productId}/userinfo?${redirectParams}`,
          );
        } else {
          this.props.history.push(
            `/products/${this.props.productInfo.productId}/address?${redirectParams}`,
          );
        }
      } else {
        const { productId } = this.props.productInfo;
        if (shouldSkipSelectPayment(this.props.productInfo)) {
          this.props.history.push(
            `/products/${productId}/placeorder?${redirectParams}`,
          );
        } else {
          this.props.history.push(
            `/products/${productId}/selectpaymentmethod?${redirectParams}`,
          );
        }
      }
    } else {
      this.props.history.push(
        `/products/${this.props.productInfo.productId}/usersearch?${redirectParams}`,
      );
    }
  }
}

export default withRouter(
  connect(
    (state: IState) => ({
      address: state.address,
      fetchUserInfo: state.fetchUserInfo,
      productInfo: state.productInfo,
      referer: state.referer,
      sessionInfo: state.sessionInfo,
      userInfo: state.userInfo,
    }),
    (dispatch) => bindActionCreators({}, dispatch),
  )(YesPlease),
);
